import { useFormat } from '@shared/hooks/useFormat';
import { GlobalMessages } from '@shared/localization/messages';
import dayjs from 'dayjs';
import { useCallback } from 'react';

import { useMessages } from '@/hooks/messages';

import type { ExportCell } from './model';

export const useFormatCell = () => {
  const messages = useMessages(GlobalMessages);
  const { formatNumber, formatDateTime, formatBoolean } = useFormat(messages.yes(), messages.no());

  return useCallback(
    (value: ExportCell) => {
      if (typeof value === 'number') {
        return formatNumber(value);
      }

      if (dayjs.isDayjs(value)) {
        return formatDateTime(value);
      }

      if (typeof value === 'boolean') {
        return formatBoolean(value);
      }

      return value ?? '';
    },
    [formatBoolean, formatDateTime, formatNumber],
  );
};
